module.exports = __webpack_public_path__ + "static/collaboration-2-76fdb33e23e27f078d964f4d6c4f111f.svg";